type Props = {
  amount: number;
  currency: string;
  baseAmount?: number;
  baseCurrency?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
};

export function formatCurrency(amount: number, currency: string): string {
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${currency} ${formatter.format(amount)}`;
}

export function CurrencyAmount({
  amount,
  currency,
  baseAmount,
  baseCurrency = "AED",
  size = "md",
  className,
}: Props) {
  const showSecondary =
    baseAmount !== undefined &&
    baseCurrency &&
    currency !== baseCurrency;

  const primarySize =
    size === "lg"
      ? "text-[24px] font-bold"
      : size === "sm"
        ? "text-[13px] font-medium"
        : "text-[15px] font-semibold";

  const secondarySize =
    size === "lg" ? "text-[14px]" : size === "sm" ? "text-[11px]" : "text-[12px]";

  return (
    <div className={className}>
      <div className={`text-foreground ${primarySize}`}>
        {formatCurrency(amount, currency)}
      </div>
      {showSecondary && (
        <div className={`text-muted-foreground ${secondarySize}`}>
          ≈ {formatCurrency(baseAmount!, baseCurrency)}
        </div>
      )}
    </div>
  );
}
